import { render } from "./Featured.vue?vue&type=template&id=0f50912c&scoped=true"
import script from "./Featured.vue?vue&type=script&lang=js"
export * from "./Featured.vue?vue&type=script&lang=js"

import "./Featured.vue?vue&type=style&index=0&id=0f50912c&lang=scss&scoped=true"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f50912c"]])

export default __exports__